<app-stepper-form
  header="Cessation of Officeholder"
  subheader="Form 484B1"
  formIcon="ic-cessation-of-officeholder-20"
  [showSteps]="false"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [form]="stepperForm"
>
  <div class="step-content" [formGroup]="stepperForm">
    <app-stepper-form-description
      formKey="484 B1"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [hidden]="currentStep !== StepsEnum.CeaseCompanyOfficeholder"
      [formGroupName]="StepsEnum.CeaseCompanyOfficeholder"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Cessation"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      @if (lateFeeMessage) {
        <app-disclaimer
          color="red"
          icon="ic-info-circle-20"
        >
          {{ lateFeeMessage }}
        </app-disclaimer>
      }

      <div class="form-group">
        <app-select
          label="Cease Officer"
          formControlName="appointedOfficerId"
          [options]="officersSelectOptions"
          [valuePrimitive]="true"
          (select)="form.controls.cessationReason.reset()"
          (selectedByHand)="onSelectAppointedOfficer($event)"
        />
      </div>

      <div class="form-group" [hidden]="!form.controls.appointedOfficerId.value">
        <app-checkbox-group
          label="Positions"
          formControlName="types"
          [options]="officerPositionTypesOptions"
        />

        @if (!this.form.controls.moreThanOneDirector.value && currentStep === StepsEnum.CeaseCompanyOfficeholder) {
          <app-notification
            class='mr-3'
            color="red"
            [text]="ceaseWarningMsg"
          />
        }
      </div>

      @if (isAlternativeDirectorSelected) {
        <div class="form-group">
          <app-select
            label='The appointed "Alternate director" is alternate for'
            noOptionsText="No directors available"
            formControlName="alternativeDirectorFor"
            [options]="alternativeDirectorsForOptions"
            [valuePrimitive]="true"
          />
        </div>
      }

      <div class="form-group">
        <app-select
          label="Reason"
          formControlName="cessationReason"
          [options]="reasonOfCessationOptions"
          [valuePrimitive]="true"
        />
      </div>

      <div class="form-group" [hidden]="noticeOfResignationHidden">
        <app-textarea
          label="Notice of Resignation"
          formControlName="noticeOfResignation"
          [rows]="3"
        />
      </div>
    </section>
  </div>
</app-stepper-form>


